/**
 * Fold a string into the form two spellings of the same word compare equal in: lower case, NFD
 * decomposed, combining marks dropped. "Rådgivning" and "radgivning" both fold to "radgivning".
 *
 * This is what the admin finance page's rate card search has always done through
 * `Util.normalizedIncludes`, which now calls this rather than repeating it. Anything matching names
 * a user typed or dictated should fold both sides first: an exact comparison against a raw name
 * fails on the accent alone, which for a Danish or German company is the common case, not an edge
 * one.
 *
 * Only canonical decomposition is undone. `ø`, `æ`, `ß` and `ł` are single letters in Unicode with
 * no decomposition, so they survive folding unchanged and still have to match exactly.
 *
 * @param value the string to fold. Null and undefined fold to the empty string.
 */
export function normalizeForSearch(value: string | null | undefined): string {
	if (value == null) {
		return '';
	}
	return value
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '');
}

/**
 * Limit string to a certain length
 * @param str Input string
 * @param limit The maximum length of the string. If set to 0 or less, the original string will be returned.
 */
export function limitString(str: string, limit: number): string {
	if (limit <= 0) {
		return str;
	}
	if (str.length > limit) {
		return str.substring(0, limit);
	}
	return str;
}
